import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import bannerBg from "@/assets/brand/banner.svg";
import tileBg from "@/assets/brand/backgrand.svg";

interface PageBannerProps {
  title: string;
  subtitle?: string;
  icon?: string;
  helpLink?: string;
  children?: ReactNode;
}

export function PageBanner({ title, subtitle, icon, helpLink, children }: PageBannerProps) {
  return (
    <div style={{
      position: "relative",
      padding: "2rem 2.5rem",
      backgroundColor: "#007270",
      backgroundImage: `url(${bannerBg}), linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${tileBg})`,
      backgroundSize: "auto 100%, cover, 75px",
      backgroundPosition: "right center, center, center",
      backgroundRepeat: "no-repeat, no-repeat, repeat",
      borderRadius: "24px",
      color: "#ffffff",
      overflow: "hidden",
      marginBottom: "2.5rem",
      boxShadow: "0 10px 30px rgba(59, 122, 114, 0.2)",
    }}>
      <div style={{ position: "relative", zIndex: 1, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div style={{ flex: 1, fontFamily: "var(--font-family-fa)" }}>
          {/* Invisible float to shape the text around the floral corner pattern */}
          <div style={{
            float: "right",
            width: "250px",
            height: "160px",
            shapeOutside: "polygon(100% 0, 0 100%, 100% 100%)",
            marginRight: "-2.5rem" /* Compensate for parent padding if needed, or just let it push text */
          }} />
          {icon && (
            <span
              style={{
                display: "inline-block",
                padding: "0.4rem 1rem",
                background: "rgba(255, 255, 255, 0.1)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderRadius: "var(--radius-pill)",
                fontSize: "0.85rem",
                color: "var(--color-text-on-dark)",
                fontWeight: "600",
                marginBottom: "1rem"
              }}
            >
              {icon}
            </span>
          )}
          <h1 className="mt-2 mb-2" style={{ fontSize: "2.2rem", fontWeight: "800", color: "var(--color-text-on-dark)", fontFamily: "var(--font-family-fa)" }}>
            {title}
          </h1>
          {subtitle && (
            <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "1.05rem", maxWidth: "600px", margin: "0" }}>
              {subtitle}
            </p>
          )}
        </div>

        {(children || helpLink) && (
          <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
            {helpLink && (
              <Link
                to={helpLink}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  padding: "0.6rem 1.1rem",
                  borderRadius: "12px",
                  background: "rgba(255, 255, 255, 0.15)",
                  color: "#ffffff",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  fontWeight: 700,
                  fontSize: "0.9rem",
                  textDecoration: "none",
                  transition: "all 0.2s ease",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                }}
              >
                <span style={{ fontSize: "1.1rem" }}>📖</span>
                <span>راهنمای صفحه</span>
              </Link>
            )}
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
